import React from 'react';
import { Ruler, Cloud, Leaf, Shield, Puzzle } from 'lucide-react';
import { whyChooseUsData } from '../mock';

const iconMap = {
  Ruler,
  Cloud,
  Leaf,
  Shield,
  Puzzle
};

export const WhyChooseUs = () => {
  return (
    <section className="relative py-24 bg-gray-900 text-white overflow-hidden">
      {/* Blueprint Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 0h1v1H0zM50 0h1v1h-1zM0 50h1v1H0zM50 50h1v1h-1z' fill='%23ffffff' fill-opacity='1' fill-rule='evenodd'/%3E%3C/svg%3E")`,
          backgroundSize: '20px 20px'
        }} />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-20">
          <div className="inline-block mb-4">
            <span className="text-sm tracking-[0.3em] uppercase text-gray-400 font-light">
              Why Choose Us
            </span>
            <div className="h-px w-16 bg-white mt-2 mx-auto" />
          </div>
          <h2 className="text-4xl lg:text-5xl font-light mb-6">
            Architect Edition Excellence
          </h2>
          <p className="text-lg text-gray-300 max-w-3xl mx-auto">
            Engineering precision meets architectural artistry in every project we deliver
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-12">
          {whyChooseUsData.map((feature, index) => {
            const Icon = iconMap[feature.icon];
            return (
              <div
                key={index}
                className="group relative"
              >
                {/* Card */}
                <div className="relative bg-white/5 backdrop-blur-sm border border-white/10 rounded-lg p-8 transition-all duration-500 hover:bg-white/10 hover:border-white/20 hover:-translate-y-2">
                  {/* Icon */}
                  <div className="mb-6">
                    <div className="w-16 h-16 rounded-lg bg-white/10 backdrop-blur-md flex items-center justify-center border border-white/20 transition-all duration-500 group-hover:scale-110 group-hover:bg-white group-hover:border-white">
                      <Icon className="w-8 h-8 text-white group-hover:text-gray-900 transition-colors duration-500" />
                    </div>
                  </div>

                  {/* Content */}
                  <h3 className="text-xl font-medium mb-4 leading-tight">
                    {feature.title}
                  </h3>
                  <p className="text-gray-300 text-sm leading-relaxed">
                    {feature.description}
                  </p>

                  {/* Decorative Line */}
                  <div className="absolute bottom-0 left-8 right-8 h-px bg-gradient-to-r from-transparent via-white/30 to-transparent transition-opacity duration-500 opacity-0 group-hover:opacity-100" />
                </div>

                {/* Blueprint-style corner decoration */}
                <div className="absolute -top-2 -left-2 w-8 h-8 border-l-2 border-t-2 border-white/20 transition-all duration-500 group-hover:w-12 group-hover:h-12 group-hover:border-white/40" />
                <div className="absolute -bottom-2 -right-2 w-8 h-8 border-r-2 border-b-2 border-white/20 transition-all duration-500 group-hover:w-12 group-hover:h-12 group-hover:border-white/40" />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};